(function() { window.GUID_c5149c36_6ffa_4131_bda6_011614511181 = { getGuid: function() { return "c5149c36-6ffa-4131-bda6-011614511181"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class Breadcrumb extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return this.$control;
            }
            OnControlInstantiation(params) {
                const me = this;
                me.controlId = params[0];
                me.$control = $('#' + params[0]);
            }
            OnDispose() {
                const me = this;
                me.$control.off(`click.${me.controlId}`);
                me.$control.remove();
            }
            OnBindEvents() {
                const me = this;
                me.$control.offon(`click.${me.controlId}`, ".breadcrumb-item", (e) => {
                    const $target = $(e.target), $breadcrumbItem = $target.closest(".breadcrumb-item"), url = $breadcrumbItem.data("href");
                    if (url != null) {
                        if (typeof url === "string") {
                            if (url.trim() !== "") {
                                CS.Lag(`click.${me.controlId}`, 10, () => {
                                    CS.Nav.Go(url);
                                });
                            }
                        }
                    }
                });
            }
        }
        Controls.Breadcrumb = Breadcrumb;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=breadcrumb.js.map
